import { routes } from 'helpers/routes'
import { getSessionStorage } from 'helpers/common'

export const redirectMainPage = (): void => {
  window.location.replace(routes.ticket.path)
}

export const handleTryAgain = (): void => {
  window.location.replace(
    getSessionStorage('pathRedirect') || routes.ticket.path,
  )
}
